import { v4 as uuid } from '@lukeed/uuid'
import { writable } from 'svelte/store'

export enum MessageType {
	Info = 'info',
	Hint = 'hint',
	Warning = 'warning',
	Error = 'error'
}

export type MessageParams = {
	text: string
	type: MessageType
	duplicate: boolean
	timeout: number
}

export type Message = {
	text: string
	type: MessageType
	id: string
}

function makeStore() {
	//const timers: Record<string, number> = {};
	const timers: any = {}
	const store = writable([] as Message[])
	const { update, subscribe } = store

	function message(params: MessageParams) {
		const id = uuid()
		const message: Message = {
			id,
			type: params.type,
			text: params.text
		}

		update((messages) =>
			messages.filter((m) => !params.duplicate && m.text !== params.text).concat([message])
		)

		//timers[id] = window.setTimeout(() => remove(id), params.timeout);
		timers[id] = setTimeout(() => remove(id), params.timeout)
		return id
	}
	function info(text: string, timeout = 7000) {
		// info messages are duplicated
		message({ text, timeout, type: MessageType.Info, duplicate: true })
	}

	function error(text: string, timeout = 3000) {
		message({ text, timeout, type: MessageType.Error, duplicate: false })
	}

	function hint(text: string, timeout = 3000) {
		message({ text, timeout, type: MessageType.Hint, duplicate: false })
	}

	function warning(text: string, timeout = 3000) {
		message({ text, timeout, type: MessageType.Warning, duplicate: false })
	}

	function remove(messageId: string) {
		clearTimeout(timers[messageId])
		update((messages) => messages.filter((m) => m.id !== messageId))
	}

	return {
		info,
		error,
		warning,
		hint,
		message,
		remove,
		subscribe
	}
}

export const messages = makeStore()
